<div class="approval-container p-4">
  <h3 class="text-xl font-semibold mb-4">Project Stage Approvals</h3>
  <div class="approvers-list">
    <div *ngFor="let approval of approvals" class="mb-3 p-3 border rounded">
      <div class="flex flex-col">
        <div class="flex justify-between items-center mb-2">
          <div class="user-info">
            <span class="font-medium">{{ approval.user.name }}</span>
          </div>

          <!-- <div class="subject-info mt-2">
            <span class="text-sm font-medium text-gray-700">{{ approval.subject }}</span>
          </div> -->

          <div class="status-section">
            <!-- TODO: this needs to be dynamic -->
            <div class="flex flex-col gap-2">
              <select
                [value]="approval.status"
                (change)="updateStatus($event, approval)"
                class="p-2 border rounded"
                [disabled]="approval.approved_at || approval.rejected_at || approval.user_id !== currentUser?.id"
              >
                <!-- TODO: these options needs to be dynamic -->
                <option
                  *ngFor="let option of statusOptions"
                  [value]="option.key"
                  [selected]="approval.status === option.key"
                >
                  {{ option.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
